import React from 'react';
import ReactBeforeSliderComponent from 'react-before-after-slider-component';
import 'react-before-after-slider-component/dist/build.css';
import { UpstagingGeneration } from '../types/restyle';

interface UpstagingResultViewerProps {
  generation: UpstagingGeneration;
}

export const UpstagingResultViewer: React.FC<UpstagingResultViewerProps> = ({ generation }) => {
  const firstImage = {
    imageUrl: generation.original_image_url,
    alt: 'Original Image'
  };

  const secondImage = {
    imageUrl: generation.upstaged_image_url,
    alt: 'Upstaged Image'
  };

  return (
    <div className="bg-white rounded-lg shadow p-6 mb-6">
      <h3 className="text-lg font-medium text-gray-900 mb-4">🚀 Upstaging Result</h3>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div>
          <h4 className="text-base font-medium text-gray-800 mb-2">Before & After Comparison</h4>
          <div className="rounded-lg overflow-hidden border border-gray-200">
            <ReactBeforeSliderComponent
              firstImage={firstImage}
              secondImage={secondImage}
              delimiterColor="#3B82F6"
              currentPercentPosition={50}
              withResizeFeel={true}
              feelsOnlyTheDelimiter={false}
              delimiterIconStyles={{
                width: '52px',
                height: '52px',
                backgroundSize: 'cover',
                borderRadius: '20%',
                backgroundImage: 'url("/assets/renovirai-logo.png")',
                backgroundColor: 'white',
                border: '3px solid #3B82F6',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat'
              }}
            />
          </div>
          <p className="text-xs text-gray-500 mt-2 text-center">
            Drag the slider to compare before and after
          </p>
        </div>
        <div>
          <h4 className="text-base font-medium text-gray-800 mb-2">Details</h4>
          <div className="space-y-2 text-sm text-gray-600">
            <div className="flex justify-between">
              <span className="font-medium">Room Type:</span>
              <span>{generation.room_type}</span>
            </div>
            <div className="flex justify-between">
              <span className="font-medium">Style:</span>
              <span>{generation.style}</span>
            </div>
            <div className="flex justify-between">
              <span className="font-medium">Generated:</span>
              <span>{new Date(generation.created_at).toLocaleDateString()}</span>
            </div>
          </div>
          {generation.prompt && (
            <div className="mt-4">
              <h5 className="text-sm font-medium text-gray-800 mb-1">Prompt:</h5>
              <p className="text-sm text-gray-600 bg-gray-50 p-2 rounded">{generation.prompt}</p>
            </div>
          )}
          <div className="mt-4 flex space-x-2">
            <a
              href={generation.original_image_url}
              target="_blank"
              rel="noopener noreferrer"
              className="flex-1 px-3 py-2 bg-gray-100 text-gray-700 rounded-md hover:bg-gray-200 transition-colors text-center text-sm font-medium"
            >
              View Original
            </a>
            <a
              href={generation.upstaged_image_url}
              target="_blank"
              rel="noopener noreferrer"
              className="flex-1 px-3 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors text-center text-sm font-medium"
            >
              View Result
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}; 